import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Line, Circle } from 'rc-progress';

export default class LoadingModal extends React.PureComponent {
  render() {
    return (<Modal
      isOpen={this.props.modalOpen}
      toggle={this.props.closeModal}
      ref="LoadingModal"
    >
      <div className="modal-header">
        <h3 className="modal-header-title">
          {this.props.header || 'Conversion in Progress' }
        </h3>
        <h4 className="modal-header-desc">
          This dialog box will disappear when the task is finished.
        </h4>
        {this.props.progress ?
          <Line percent={this.props.percent} strokeWidth="2" trailWidth="2" strokeColor="#2db7f5" /> : null}
      </div>
      <ModalBody>
        <div className="loading">
          <img src="/assets/loading.gif" />
        </div>
      </ModalBody>
    </Modal>);
  }
}
